import styled from '@emotion/styled';

const LabeledDivider = styled.span`
  display: flex;
  flex-direction: row;
  width: 80%;
  margin: 10px;

  &::before,
  &::after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid;
    margin: auto;
  }
  &::before {
    margin-right: 10px;
  }
  &::after {
    margin-left: 10px;
  }
  ${(props) => `color: ${props.theme.palette.text.secondary};`}
`;

export default LabeledDivider;
